export default __webpack_public_path__ + "static/media/Neysa Fligor.7857419e.jpg";